import type { GridSortModel } from '@mui/x-data-grid-pro';
import type { SortDto } from '@tempo-io/roadmap-dto';
import { dequal } from 'dequal';
import * as React from 'react';
import { useSortableItemFields } from '@/lib/queries/common/useItemFieldsQuery';
import { buildOrderString } from './sortableItemFields';
import { buildTableColumnField, parseTableColumnField } from './tableColumnUtils';

export type OnSortModelChange = (sort: SortDto) => void;

export const useSortModel = (sort?: SortDto, onSortModelChange?: OnSortModelChange) => {
  const { sortableItemFields } = useSortableItemFields();
  const { type, customFieldId, order } = sort ?? {};
  const [initialSortModel] = React.useState<GridSortModel>(() => {
    if (!type || buildOrderString(sort, sortableItemFields) === undefined) return [];
    return [
      {
        field: buildTableColumnField({ type, customFieldId }),
        sort: order,
      },
    ];
  });

  const onItemsTableSortModelChange = onSortModelChange
    ? (newSortModel: GridSortModel) => {
        const firstSortItem = newSortModel[0];
        const newSort: SortDto = firstSortItem
          ? {
              ...parseTableColumnField(firstSortItem.field),
              order: firstSortItem.sort === 'desc' ? 'desc' : 'asc',
            }
          : { type: 'customField', customFieldId: null, order: 'asc' };

        if (!dequal(sort, newSort)) {
          onSortModelChange(newSort);
        }
      }
    : undefined;

  return { initialSortModel, onItemsTableSortModelChange };
};
